import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage } from './Dynamictable';
import {clrwidgate,stvlsn,loadwidgate,gtpblvl,gtvlacht,entervilla,setdefaulvillachat,villachanged,usermoved} from './userdefaultdata';
import Usersession from './Usersession';

export default class Viewpvtvillas extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
        name: "World",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c'}],	
       
       tblfiterdata: [{muid:0,mvillaid:"",mvillaname:"",mvt:2,mucnt:0}]
 	
    };

    
   searchvilla(e: any){
 	// alert('ok');

	e.preventDefault();
	
    }

    
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
 
 closevilla(e:any,id:any,vnm:any){
         const removevillaid = Usersession.getVillaId();

    Usersession.setVillatype('2');
      setdefaulvillachat();
        Usersession.setVillasts(1);

        const vlid = parseInt(id);
        const userid = Usersession.getUserId();
        entervilla(id,vnm,vlid,'2');
      
           villachanged();
          
         usermoved(id,removevillaid);

        const vsts =  Usersession.getVillasts();
        if(vsts != 0) {
	loadwidgate('wigtarea',2);
       getmessage('Please try again....','')
        }

       //this.checkvillastatus(id,vnm,userid);
	

         e.preventDefault();

   }
   checkvillastatus(id:any,vnm:any,userid:any){
 try {
         const path = Configdata.srvurl + '/chekvillasts?uid='+userid +'&vid='+id; 
 	//alert(path);	
	axios.get(path)
            .then((response: any) => {
               
		const tdata = response.data;
               // alert(JSON.stringify(tdata));
		if(tdata != 'OK')
                 getmessage(tdata,'');
               

            })
            .catch((err: any) => {
             
            });

                
          }
        catch (e) {
         
        }

   }
    componentDidMount() {
        debugger;
        const tuserid = Usersession.getUserId();
	const ispvtsr = Usersession.getPvtvlsrch();

       if(!ispvtsr)
	this.getpvtvilladata('0','0','na');
	else
	this.getpvtvilladata('2',tuserid,'na');

        const pid = localStorage.getItem("id");
        
       // this.setserverurl();
        const ar = [{id:1, nm: 'c'},{id:2, nm: 'd'}]
	
	const cols = ["Villa Name"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
	
	Usersession.setPvtvlsrch(false);

       

    }
 searchbytxt(e:any){
    const ctb = document.getElementById('searchtxt') as HTMLInputElement;
        var tx = ctb.value.trim();
       if(tx !== null && tx != ""){
	this.getpvtvilladata('1','0',tx);

	}
    e.preventDefault();

}
 getpvtvilladata(op:any,eid: any,qt:any){
	 try {
         const path = Configdata.srvurl + '/getpvtvlla?uid='+eid +'&opt='+op+'&qt='+qt; 
 	//alert(path);	
	axios.get(path)
            .then((response: any) => {
               
		const tdata = response.data;
               // alert(JSON.stringify(tdata));
		this.convertpvtvarry(tdata);
            })
            .catch((err: any) => {
                //alert(err);
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
        // alert(JSON.stringify(farr));
	if(farr.length > 1) farr.shift();
	this.setState({ tblfiterdata: farr});
      }	
 convertpvtvarry(arr: any){
     let farr = [{muid:0,mvillaid:"",mvillaname:"",mvt:2,mucnt:0}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                let obj = {muid:0,mvillaid:"",mvillaname:"",mvt:2,mucnt:0}
                 const rv = arr[i];
		 if(rv){
		  obj['muid'] = rv[0];
                  obj['mvillaid'] = rv[1];
		  obj['mvillaname'] = rv[2];
		  obj['mvt'] = rv[3];
		 obj['mucnt'] = rv[4];

		 }
		 farr.push(obj);
		 
		}
	    }
	 }
         //alert(JSON.stringify(farr));
	if(farr.length > 1) farr.shift();
	this.setState({ tblfiterdata: farr});
      }	

    
 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			<input id="searchtxt" type="text" onKeyUp={e=>this.searchvilla(e)} className="c-txtbox"/>
                       <a href="#" className="blanka"  onClick={e=>this.searchbytxt(e)} title="Search" > 
			<div className="btnesearch"><span className="esearchtxt"> ...</span>  </div> 
                       </a>
	
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
			<tr>
                        <td>
			<a href="#" className="blanka"  onClick={e=>this.closevilla(e,row.mvillaid,row.mvillaname)} title="Villa" > 
                                    <div>
                                    {row.mvillaname}
                                     {row.mucnt > 0?(
					<span>({row.mucnt})</span>
					):(
					<span style={{display:'none'}}>({row.mucnt})</span>
					)
				     }									
                                    </div>
		        </a>

			</td>	
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

